<!--

TODO:
-  dodat pattern na background

-->

<template>
  <section>
    <div class="container">
      <h1>Prijavi se i...</h1>
      <div class="block">
        <figure>
          <div class="icon">
            <img src="../../assets/icons/laptop.svg" alt="Laptop">
          </div>
          <figcaption>
            <h2>Pobijedi u nagradnoj igri</h2>
            <p>Priključi se utrci za glavnu nagradnu igru i osvoji vrijedne nagrade.</p>
          </figcaption>
        </figure>
        <figure>
          <div class="icon">
            <img src="../../assets/icons/handshake.svg" alt="Rukovanje">
          </div>
          <figcaption>
            <h2>Pokaži što znaš</h2>
            <p>Prijavi se na fly talks i radionice te dođi korak bliže poslu.</p>
          </figcaption>
        </figure>
      </div>
      <div class="image">
        <img src="../../assets/visuals/mobile-app.png" alt="Aplikacija">
      </div>
      <div class="block block--two">
        <figure>
          <div class="icon">
            <img src="../../assets/icons/schedule.svg" alt="Raspored">
          </div>
          <figcaption>
            <h2>Napravi svoj raspored</h2>
            <p>Odaberi ona predavanja koja ti se najviše sviđaju i sastavi svoj raspored.</p>
          </figcaption>
        </figure>
        <figure>
          <div class="icon">
            <img src="../../assets/icons/exclusive.svg" alt="Ekskluzivno">
          </div>
          <figcaption>
            <h2>Saznaj ekskluzivne informacije</h2>
            <p>Dobij pristup najnovijim i najzanimljivijim informacijama o konferenciji.</p>
          </figcaption>
        </figure>
      </div>
      <div class="button-wrapper">
        <div class="dots">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <button class="button" v-on:click="$emit('showLoginModal')">PRIJAVA</button>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "MobileHero",
    data() {
      return {
        slideIndex: 1,
        figures: [],
        dots: [],
        refreshIntervalId: 0
      }
    },
    methods: {
      carousel: function() {
        this.figures.forEach(fig => fig.style.opacity = 0);
        this.dots.forEach(dot => dot.classList.remove('active'));

        this.figures[this.slideIndex-1].style.opacity = 1;
        this.dots[this.slideIndex-1].classList.add('active');

        this.slideIndex++;

        if(this.slideIndex > this.figures.length)
          this.slideIndex = 1;
      }
    },
    mounted() {
      if(window.innerWidth < 1024 && document.getElementsByTagName('figure') && document.getElementsByClassName('dot'))
      {
        this.figures = [...document.getElementsByTagName('figure')];
        this.dots = [...document.getElementsByClassName('dot')];
        this.carousel();
        this.refreshIntervalId = setInterval(this.carousel, 3000);
      }
    },
    beforeDestroy() {
      if(this.refreshIntervalId)
        clearInterval(this.refreshIntervalId);
    }
  };
</script>

<style scoped>
section {
  background-image: url("../../assets/patterns/visual-identity.png");
}

h1 {
  color: #ffffff;
  font-family: "Fuse V.2 Display";
  font-size: 36px;
  font-weight: 800;
  line-height: 44px;
}

section {
  padding-top: 50px;
  padding-bottom: 55px;
  background-color: #30cec1;
}

.button {
  background-color: #2c373f;
  display: table;
  margin-left: auto;
  margin-right: auto;
}

figure > .icon {
  padding: 12px 15px;
  background-color: #2c373f;
  width: 60px;
  height: 60px;
  margin-right: 30px;
  display: flex;
  justify-content: center;
}

.image {
  margin-top: 35px;
  width: 100%;
  margin-bottom: 55px;
  text-align: center;
}

.image img {
  max-width: 375px;
}

figure {
  display: flex;
}

h2 {
  color: #000000;
  font-family: "Fuse V.2 Display";
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.22px;
  line-height: 33px;
  max-width: 215px;
}

p {
  color: rgb(0, 0, 0, 0.65);
  font-family: "Fuse V.2 Display";
  font-size: 16px;
  letter-spacing: -0.21px;
  line-height: 24px;
  max-width: 235px;
}

figcaption {
  flex: 1;
}

.dots {
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
}

.dot {
  margin: 0 10px;
  height: 5px;
  width: 15px;
  border-radius: 8px;
  background-color: rgb(0, 0, 0, 0.6);
}

.dot.active {
  background-color: #2c373f;
  width: 25px;
}


@media screen and (max-width: 1024px) {
  figure {
    opacity: 0;
    position: absolute;
    top: 75%;
  }

  .container {
    position: relative;
  }

  .block,
  .block--two {
    height: 125px;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
  }

  .block {
    height: 0;
  }

  .image {
    margin-bottom: 150px;
  }
}

@media screen and (max-width: 768px) {
  .image img {
    max-width: 340px;
  }
}


@media screen and (max-width: 380px) {
  .image img {
    max-width: 310px;
  }

  figure {
    top: 73%;
  }
}

@media screen and (min-width: 1024px) {
  section > .container::after {
    clear: both;
    display: table;
    content: "";
  }

  .dots {
    display: none;
    margin-bottom: 0;
  }

  section {
    padding-bottom: 80px;
  }

  figure:first-of-type {
    margin-bottom: 135px;
    height: 170px;
  }

  .block {
    display: block;
  }

  h1 {
    width: 100%;
    text-align: center;
    line-height: 65px;
    font-size: 54px;
    margin-bottom: 80px;
  }

  .block {
    width: 27.5%;
    float: left;
    padding-top: 35px;
  }
  .image {
    width: 45%;
    float: left;
    padding: 0 50px;
    margin-bottom: 0;
    margin-top: 0;
  }

  h2 {
    font-size: 24px;
    letter-spacing: -0.27px;
    line-height: 33px;
  }

  p {
    font-size: 18px;
    letter-spacing: -0.24px;
    line-height: 30px;
  }

  .button-wrapper {
    text-align: center;
    float: left;
    width: 100%;
    margin-top: 80px;
  }

  .button {
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.27px;
    line-height: 25px;
    padding: 12.5px 50px;
    border-radius: 35.16px;
  }
}

@media screen and (max-width: 1250px) {
  .container {
    width: 95%;
  }
}
</style>